// extracted by mini-css-extract-plugin
export default {"container":"AuthPage_container__NglKK","google-btn":"AuthPage_google-btn__WTcA7","google-img":"AuthPage_google-img__9AtD6","text-carregamento":"AuthPage_text-carregamento__fHMzb"};